(() => {
  'use strict';
  let adding = false;
  const root = window.Shopify?.routes?.root || '/';
  async function request(path, body) {
    const response = await fetch(root + path, body ? {
      method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(body)
    } : {});
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || 'Unable to add your sample. Please try again.');
    return data;
  }
  async function addSample(button) {
    if (adding) return;
    adding = true;
    const original = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding to basket…';
    document.querySelectorAll('[data-sample-error]').forEach(el => el.remove());
    try {
      const product = await request('products/' + encodeURIComponent(button.dataset.handle) + '.js');
      const variant = product.variants.find(v => v.available);
      if (!variant) throw new Error('This sample is currently unavailable. Please contact us for an alternative.');
      await request('cart/add.js', {items: [{id: variant.id, quantity: 1, properties: {_cc_sample: 'true'}}]});
      button.textContent = 'Added to basket ✓';
      let confirmation = button.nextElementSibling;
      if (!confirmation?.matches('[data-sample-confirmation]')) {
        confirmation = document.createElement('p');
        confirmation.dataset.sampleConfirmation = '';
        confirmation.setAttribute('role', 'status');
        confirmation.setAttribute('aria-live', 'polite');
        button.insertAdjacentElement('afterend', confirmation);
      }
      confirmation.replaceChildren(document.createTextNode('Sample added. '));
      const basketLink = document.createElement('a');
      basketLink.href = root + 'cart';
      basketLink.textContent = 'View basket';
      confirmation.append(basketLink);
      // A failed count refresh must not report a successful addition as failed.
      try {
        const cart = await request('cart.js');
        document.querySelectorAll('.cc-sample-toggle').forEach(link => {
          link.setAttribute('aria-label', 'Basket, ' + cart.item_count + ' items');
          let count = link.querySelector('span');
          if (!count) {
            count = document.createElement('span');
            count.setAttribute('aria-hidden', 'true');
            link.append(count);
          }
          count.textContent = cart.item_count;
        });
      } catch (_) { /* Keep the confirmed addition visible. */ }
      adding = false;
      window.setTimeout(() => {
        button.disabled = false;
        button.textContent = original;
      }, 1500);
    } catch (error) {
      const message = document.createElement('p');
      message.dataset.sampleError = '';
      message.setAttribute('role', 'alert');
      message.textContent = error.message || 'Unable to add your sample. Please try again.';
      button.insertAdjacentElement('afterend', message);
      button.disabled = false;
      button.textContent = original;
      adding = false;
    }
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-sample-add]');
    if (button) { event.preventDefault(); addSample(button); }
  });
  function syncQuery() {
    const params = new URLSearchParams(location.search);
    const brief = document.getElementById('CCBrief');
    if (brief && params.get('veneer') && !brief.value.trim()) brief.value = 'I would like a quotation for ' + params.get('veneer') + '.\n\n';
    if (params.get('request') === 'samples') window.location.replace(root + 'cart');
  }
  window.addEventListener('pageshow', () => {
    adding = false;
    document.querySelectorAll('[data-sample-add]').forEach(button => { button.disabled = false; button.textContent = 'Add sample +'; });
  });
  document.addEventListener('shopify:section:load', syncQuery);
  syncQuery();
})();
